/* Keep the customer's single size input aligned with native Prestige variants. */
(() => {
  const values = new Map();
  const normalize = value => String(value).trim().replace(/^US\s*/i, '').replace(',', '.').replace(/^(\d+)(?:\.0+)?$/, '$1');
  customElements.whenDefined('variant-picker').then(() => {
    if (customElements.get('seny-ring-size')) return;
    class SenyRingSize extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('[data-seny-ring-size-input]');
        this.form = document.getElementById(this.dataset.formId);
        if (!this.input || !this.form) return;
        this.picker = document.querySelector(`variant-picker[form-id="${CSS.escape(this.dataset.formId)}"]`);
        this.fieldset = this.picker?.querySelector('[data-seny-ring-size-option]');
        this.radios = [...(this.fieldset?.querySelectorAll('input[type="radio"][data-seny-ring-size-value]') || [])];
        this.state = values.get(this.dataset.formId) || { value: '', pending: null, error: '', queued: false };
        values.set(this.dataset.formId, this.state);
        if (this.radios.length) this.fieldset.hidden = true;
        this.restore();
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.input.addEventListener('input', () => {
          this.state.value = this.input.value;
          this.state.error = '';
          this.validate();
        }, options);
        this.input.addEventListener('blur', event => {
          // Do not replace the customer's target button before its click fires.
          if (event.relatedTarget?.closest('button, variant-picker')) return;
          void this.sync();
        }, options);
        this.form.addEventListener('submit', event => {
          if (!this.validate()) {
            event.preventDefault(); event.stopImmediatePropagation(); this.input.reportValidity(); return;
          }
          const match = this.match();
          if (!this.state.pending && (!match || match.checked)) return;
          event.preventDefault(); event.stopImmediatePropagation();
          if (this.state.queued) return;
          this.state.queued = true;
          const submitterName = event.submitter?.name || '';
          this.sync().then(ok => {
            this.state.queued = false;
            if (!ok) return;
            const current = this.current();
            if (!current?.validate()) return;
            const available = [...current.form.elements].filter(el => el.type === 'submit' && !el.disabled);
            const submitter = available.find(el => el.name === submitterName) || available[0];
            if (submitter) current.form.requestSubmit(submitter);
          });
        }, { capture: true, signal: this.abort.signal });
      }
      disconnectedCallback() { this.abort?.abort(); }
      current() {
        return [...document.querySelectorAll('seny-ring-size')].find(el => el.dataset.formId === this.dataset.formId);
      }
      match() { return this.radios.find(radio => normalize(radio.dataset.senyRingSizeValue) === normalize(this.state.value)); }
      validate() {
        let message = this.state.error;
        if (!message && this.state.value.trim() && this.radios.length && !this.match()) {
          message = `Please enter an available US ring size: ${this.radios.map(radio => radio.dataset.senyRingSizeValue).join(', ')}.`;
        }
        this.input.setCustomValidity(message);
        return this.input.validity.valid;
      }
      restore() {
        this.input.value = this.state.value;
        this.input.readOnly = !!this.state.pending;
        if (this.picker) this.picker.inert = !!this.state.pending;
        this.validate();
      }
      sync() {
        if (this.state.pending) return this.state.pending;
        if (!this.validate()) return Promise.resolve(false);
        const match = this.match();
        if (!match || match.checked) return Promise.resolve(true);
        const previous = this.radios.find(radio => radio.checked);
        match.checked = true;
        const optionValues = [...this.form.elements]
          .filter(el => el.matches('input[data-option-position]:checked'))
          .sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition))
          .map(el => el.value);
        this.state.pending = this.picker.selectCombination({ optionValues, productChange: false })
          .then(() => true)
          .catch(() => {
            if (previous) previous.checked = true;
            this.state.error = 'We could not update your ring size. Please re-enter your size and try again.';
            return false;
          })
          .finally(() => {
            this.state.pending = null;
            this.current()?.restore();
          });
        this.restore();
        return this.state.pending;
      }
    }
    customElements.define('seny-ring-size', SenyRingSize);
  });
})();
